import React from 'react'
import styled from 'styled-components'

const Icon = styled.svg.attrs({
  version: '1.1',
  xmlns: 'http://www.w3.org/2000/svg',
  xmlnsXlink: 'http://www.w3.org/1999/xlink',
  viewBox: '0 0 54 512',
})``

const Svg = styled(Icon)`
  width: 100px;
  height: 1344px;
`

function WaveSeparator({ className }: { className?: string }) {
  return (
    <Svg className={className}>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path
          d="M0 512C34.6604 423.89 54 339.22 54 250C54 160.78 34.6604 76.11 0 0V500Z"
          fill="currentColor"
        ></path>
      </g>
    </Svg>
  )
}

export default WaveSeparator
